import { Component, OnInit, inject, viewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Bar, BarManagementService, BarQuery, BarQueryResponse } from 'src/app/api/api-bar-management.service.generated';
import { OutletProperty, OutletPropertyItem } from 'src/app/api/api-campaigns.service.generated';
import { OutletPropertiesComponent } from 'src/app/common/components/outlet-properties/outlet-properties.component';
import { OutletPropertiesConverter } from './outlet-properties-converter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-outlet-property-select',
  templateUrl: './outlet-property-select.component.html',
  styleUrls: ['./outlet-property-select.component.scss'],
  imports: [
    OutletPropertiesComponent,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTableModule,
    MatDialogModule
  ]
})
export class OutletPropertySelectComponent implements OnInit {
  private bmApi = inject(BarManagementService);
  private dialogRef = inject<MatDialogRef<OutletPropertySelectComponent>>(MatDialogRef);


  static async open(dialog: MatDialog): Promise<OutletPropertyItem[] | undefined> {
    const result = await lastValueFrom(dialog.open(OutletPropertySelectComponent, { width: '600px', height: '600px', data: undefined }).afterClosed());
    return result as (OutletPropertyItem[] | undefined);
  }

  readonly outletPropertiesView = viewChild<OutletPropertiesComponent>('outletPropertiesView');

  isLoading = false;
  outlets: Bar[] = [];
  res: BarQueryResponse;

  outletProperties: string[] = [];

  onSearch() {
    this.refresh();
  }

  async refresh() {
    if (this.outletProperties.length === 0) {
      this.outlets = [];
      return;
    }

    try {
      this.isLoading = true;
      const allProps = OutletPropertiesConverter.toProps(this.outletProperties).map(kv => new OutletPropertyItem({ outletProperty: kv.outletProperty, value: kv.value })); // remove invalid values
      const adl1props = allProps.filter(x => x.outletProperty == OutletProperty.AdministrativeAreaL1).map(x => x.value);
      const adl2props = allProps.filter(x => x.outletProperty == OutletProperty.AdministrativeAreaL2).map(x => x.value);
      const res = await lastValueFrom(this.bmApi.queryBars(new BarQuery({ administrativeAreaL1s: adl1props, administrativeAreaL2s: adl2props, skip: 0, maxItems: 100 })));
      this.outlets = res.items;
      this.res = res;
    } finally {
      this.isLoading = false;
    }
  }


  ngOnInit() {
  }

  onOutletPropertiesChanged() {
    // I don't really understand what this does
    OutletPropertiesConverter.toProps(this.outletProperties) as OutletPropertyItem[]; // remove invalid values
  }

  onSelect() {
    const props = OutletPropertiesConverter.toProps(this.outletProperties); // remove invalid values
    if (props.length === 0) return;

    this.dialogRef.close(props);
  }
}
